<!--折扣查询-->
<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-select v-model="filters.discountId" placeholder="折扣活动" filterable clearable>
                    <el-option v-for="item in options_discount" :label="item.name" :value="item.id" v-bind:key="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.discountExpireBeginTime" type="date" placeholder="折扣到期开始" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.discountExpireEndTime" type="date" placeholder="折扣到期截至" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.activeBt" type="date" placeholder="激活开始日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.activeEt" type="date" placeholder="激活截止日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filters.likeCardKey" placeholder="输卡号/ICCID/IMSI/查询码"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" v-on:click="getCards">查询</el-button>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="exportExcel">导出EXCEL</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="cards" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
        <el-table-column prop="msisdn" label="物联卡号" width="150">
        </el-table-column>
        <el-table-column prop="discountName" label="折扣名称" width="150">
        </el-table-column>
        <el-table-column prop="discountExpireTime" label="折扣到期" width="150">
        </el-table-column>
        <el-table-column prop="openAccountTime" label="开户时间" width="150">
        </el-table-column>
        <el-table-column prop="activeDate" label="激活日期" width="150">
        </el-table-column>
        <el-table-column prop="expiretime" label="到期时间" width="150">
        </el-table-column>
        <el-table-column prop="cardstate" label="卡状态" width="100">
        </el-table-column>
        <el-table-column prop="packagename" label="使用套餐" min-width="150">
        </el-table-column>
        <el-table-column prop="currentmoney" label="用户余额" width="120">
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
                <!-- <el-button size="small" @click="updateCard(scope.$index, scope.row)">编辑</el-button> -->
                <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条(分页)-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--卡号信息详情界面-->
    <cardinfo ref="cardinfo"></cardinfo>

</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getAllDiscount,
    getlikeDiscountCards
} from '../../api/api';
import Cardinfo from '../../components/card_info.vue';

export default {
    components: {
        cardinfo: Cardinfo
    },
    data() {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return false;
                }
            },
            options_discount: [],
            filters: {
                discountId: '',
                discountExpireBeginTime: '',
                discountExpireEndTime: '',
                //激活开始日期
                activeBt: '',
                //激活截至日期
                activeEt: '',
                likeCardKey: ''
            },
            cards: [],
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            sels: [] //列表选中列
        }
    },
    methods: {
        //性别显示转换
        formatSex: function (row, column) {
            return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        exportExcel() {
            this.filters.discountExpireBeginTime = (!this.filters.discountExpireBeginTime || this.filters.discountExpireBeginTime == '') ? '' : util.formatDate.format(new Date(this.filters.discountExpireBeginTime), 'yyyy-MM-dd');
            this.filters.discountExpireEndTime = (!this.filters.discountExpireEndTime || this.filters.discountExpireEndTime == '') ? '' : util.formatDate.format(new Date(this.filters.discountExpireEndTime), 'yyyy-MM-dd');
            this.filters.activeBt = (!this.filters.activeBt || this.filters.activeBt == '') ? '' : util.formatDate.format(new Date(this.filters.activeBt), 'yyyy-MM-dd');
            this.filters.activeEt = (!this.filters.activeEt || this.filters.activeEt == '') ? '' : util.formatDate.format(new Date(this.filters.activeEt), 'yyyy-MM-dd');

            let para = "";
            para += "discountId=" + ((!this.filters.discountId || this.filters.discountId == '') ? '' : this.filters.discountId);
            para += "&discountExpireBeginTime=" + this.filters.discountExpireBeginTime;
            para += "&discountExpireEndTime=" + this.filters.discountExpireEndTime;
            para += "&activeBt=" + this.filters.activeBt;
            para += "&activeEt=" + this.filters.activeEt;
            para += "&likeCardKey=" + ((!this.filters.likeCardKey || this.filters.likeCardKey == '') ? '' : this.filters.likeCardKey);
            location.href = "/api/discount/card/like/excel?" + para;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCards();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCards();
        },
        //获取卡号列表
        getCards() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            para = Object.assign(para, this.filters);
            para.discountExpireBeginTime = (!para.discountExpireBeginTime || para.discountExpireBeginTime == '') ? '' : util.formatDate.format(new Date(para.discountExpireBeginTime), 'yyyy-MM-dd');
            para.discountExpireEndTime = (!para.discountExpireEndTime || para.discountExpireEndTime == '') ? '' : util.formatDate.format(new Date(para.discountExpireEndTime), 'yyyy-MM-dd');
            para.activeBt = (!para.activeBt || para.activeBt == '') ? '' : util.formatDate.format(new Date(para.activeBt), 'yyyy-MM-dd');
            para.activeEt = (!para.activeEt || para.activeEt == '') ? '' : util.formatDate.format(new Date(para.activeEt), 'yyyy-MM-dd');

            this.listLoading = true;
            //NProgress.start();
            getlikeDiscountCards(para).then((res) => {
                this.total = res.data.total;
                this.cards = res.data.list;
                this.listLoading = false;
                //NProgress.done();
            });
        },
        //显示卡号详细界面
        handleMore: function (index, row) {
            this.$refs.cardinfo.showCardDetail(row.msisdn);
        }
    },
    mounted() {
        let para = {};
        getAllDiscount(para).then((res) => {
            this.editLoading = false;
            this.options_discount = res.data;
        });
        this.getCards();
    }
}
</script>



// WEBPACK FOOTER //
// discountCard.vue?e629ba9c